import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import generatorPlayUrl from '@/utils/generatorPlayUrl';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function ProductMedia({ langKey, mediaList, mediaBanner, theme }: any) {
    const { useRouter, useState, useLang, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(langKey);
    const [videoModal, setVideoModal] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');

    const handlePlayVideo = (e: any, video: any, k: number) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: t(video.title) || video.title,
            position: `Media_${k + 1}`,
        });
        if (video?.link) {
            setVideoUrl(video?.link);
            setVideoModal(true);
            return;
        }
        const target = e.target?.closest('.mask');
        if (!target?.classList.contains('play')) return;
        const { url, isYoutube } = target.dataset;
        if (isYoutube === 'true') {
            setVideoUrl(url);
            setVideoModal(true);
        } else {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.click();
        }
    };

    return (
        <section className={`product-media ${css['product-media']} ${theme}`}>
            {mediaBanner && (
                <div className="media-banner">
                    <div className="banner-img">
                        <EFPicture
                            src={mediaBanner?.img}
                            srcPad={mediaBanner?.imgPad || mediaBanner.img}
                            srcMobile={mediaBanner?.imgMobile || mediaBanner?.imgPad || mediaBanner.img}
                            alt={t(mediaBanner?.title)}
                        />
                    </div>
                    <p className="banner-title">{t(mediaBanner?.title)}</p>
                </div>
            )}
            <ul className="media-videos">
                {mediaList?.map((video: any, k: number) => (
                    <li className="media-video" key={k}>
                        <div
                            onClick={(e: any) => handlePlayVideo(e, video, k)}
                            className="video-img play mask"
                            data-url={video?.fileUrl ? generatorPlayUrl(video?.fileUrl).url : ''}
                            data-is-youtube={video?.fileUrl ? generatorPlayUrl(video?.fileUrl)?.isYouTubeVideo : ''}
                        >
                            <EFPicture
                                src={video?.poster || generatorPlayUrl(video?.fileUrl)?.imageUrl || '/img/search/error.png'}
                                alt={video?.link ? t(video.title) : video.title}
                            />
                            <svg className="play-icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM28.0661 20.8524C28.7021 20.4621 28.7021 19.538 28.0661 19.1477L18.1781 13.0801C17.5118 12.6712 16.6551 13.1507 16.6551 13.9324V26.0677C16.6551 26.8495 17.5118 27.3289 18.1781 26.92L28.0661 20.8524Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                        <p data-url={video?.fileUrl || ''} className="video-title">
                            {t(video.title) || video.title}
                        </p>
                    </li>
                ))}
            </ul>
            <EFVideoModal visible={videoModal} source={videoUrl} onClose={() => setVideoModal(false)} playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'} />
        </section>
    );
}
